<template>
  <Card class="p-4 rounded-2xl" :data-test-id="`giftcard-step-${step}`">
    <div class="flex items-center gap-2">
      <span
        class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal-400 text-xs font-semibold text-white"
      >
        {{ step }}
      </span>
      <h2 class="text-base font-semibold text-stone-800">{{ title }}</h2>
      <button
        v-if="!open"
        type="button"
        data-test-id="giftcard-step-edit"
        class="ml-auto text-sm font-medium text-teal-800 underline lg:hidden"
        @click="emit('edit')"
      >
        {{ t('personalization.theme.edit') }}
      </button>
    </div>
    <p
      v-if="!open && summary"
      data-test-id="giftcard-step-summary"
      class="mt-1 ml-8 truncate text-sm text-stone-600 lg:hidden"
    >
      {{ summary }}
    </p>

    <!-- v-show, not v-if: the step's fields (and their exposed checkError)
         must stay mounted so Checkout can validate a closed step.
         Desktop keeps every step open, so lg:!block beats v-show's inline display:none -->
    <div v-show="open" class="mt-4 lg:!block">
      <slot />
      <Button
        v-if="showNext"
        variant="outlined"
        class="mt-4 w-full md:w-auto px-6 py-2 rounded-lg lg:hidden"
        data-test-id="giftcard-step-next"
        @click="emit('next')"
      >
        {{ t('personalization.theme.next') }}
      </Button>
    </div>
  </Card>
</template>

<script setup lang="ts">
const { t } = useI18n()

const { showNext = false, summary = '' } = defineProps<{
  step: number
  title: string
  open: boolean
  /** shown under the title while the step is closed */
  summary?: string
  showNext?: boolean
}>()

const emit = defineEmits<{
  edit: []
  next: []
}>()
</script>
